import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import {
  collapseBuildTypeBranchesSection,
  expandBuildTypeBranchesSection,
} from '../../../../../../actions'
import {withBuildTypeId} from '../../../../../../hooks/routes'
import type {State} from '../../../../../../reducers/types'
import {isBuildTypeBranchesSectionCollapsed} from '../../../../../../selectors'

import CollapsibleBranchLines from './CollapsibleBranchLines'
import type {ActionProps, ReduxOwnProps, StateProps} from './CollapsibleBranchLines.types'

const mapStateToProps = (
  state: State,
  {buildTypeId, branchesToShow}: ReduxOwnProps,
): StateProps => ({
  expanded: !isBuildTypeBranchesSectionCollapsed(state, buildTypeId, branchesToShow),
})

const actionCreators: ActionProps = {
  onExpand: expandBuildTypeBranchesSection,
  onCollapse: collapseBuildTypeBranchesSection,
}
export default compose(
  withBuildTypeId,
  connect(mapStateToProps, actionCreators),
)(CollapsibleBranchLines)
